import React from 'react';
import { Flex, Text, Spinner } from '@chakra-ui/react';

/**
 * MI-139 — the one way to ask for more.
 *
 * The Movements page used to paginate three different ways: numbered pages of
 * *dates* in the flat list, a "show more" for group headers, and another for
 * the rows inside a group. Three mechanisms in one screen, and a board that
 * simply stopped at its cap without saying so.
 *
 * Everything appends now, and it appends through this button, so the gesture
 * is the same whether you are asking for more movements, more groups or more
 * columns. `hint` carries what the page numbers used to say for free — how
 * much of the whole you are looking at.
 *
 * The board has it too since MI-326. Its group cap still counts the server's
 * rows (a group once per currency) rather than the columns you can see, so the
 * button can turn up before a full page of columns is on screen. That was
 * accepted: a board that stops at its cap without saying so hides the rest
 * outright.
 */
const LoadMoreButton = ({ onClick, isLoading = false, label, hint }) => {
  if (isLoading) {
    return (
      <Flex justify="center" align="center" py={2} w="100%">
        <Spinner size="xs" color="redesign.text.muted" />
      </Flex>
    );
  }

  return (
    <Flex
      as="button"
      type="button"
      onClick={onClick}
      direction="column"
      align="center"
      justify="center"
      gap={0.5}
      py={2}
      px={3}
      w="100%"
      borderRadius="md"
      border="1px solid"
      borderColor="redesign.border"
      color="redesign.text.muted"
      fontSize="xs"
      fontWeight="500"
      _hover={{ bg: 'redesign.bg.hover', color: 'redesign.text' }}
      transition="background 0.12s, color 0.12s"
    >
      <Text fontSize="xs">{label}</Text>
      {/* Its own line: the count is context, not part of the action, and side
          by side the two read as one long sentence. */}
      {hint && (
        <Text fontSize="2xs" color="redesign.text.faint" fontWeight="400">{hint}</Text>
      )}
    </Flex>
  );
};

export default LoadMoreButton;
